import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import style from './BalanceInfo.scss';

const cn = bemCssModules(style, 'BalanceInfo');
const ti = getTestId('BalanceInfo');

export type TBalanceInfo = {
  fiat?: string;
  className?: string;
};

const BalanceInfo: CustomFC<TBalanceInfo> = ({ fiat, className }) => (
  <div className={cn(null, [className])} data-testid={ti()}>
    <div data-testid={ti('fiat')}>{fiat}</div>
  </div>
);

export default BalanceInfo;
